var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "5px 0px 5px 10px"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "sk-cube-grid"
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : (_vm.tree && _vm.children.length > 0) ? _c('div', {
    staticClass: "tree-container sidebar",
    staticStyle: {
      "width": "100%",
      "text-align": "right",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    },
    style: ({
      'max-height': _vm.mh ? _vm.mh + 'px' : 'unset'
    }),
    attrs: {
      "id": "scroll-uses"
    }
  }, _vm._l((_vm.children), function(child, index) {
    return _c('use-list-item', {
      key: index,
      attrs: {
        "branch": child,
        "isFirstSon": true,
        "isLastSon": index == _vm.children.length - 1,
        "isChild": _vm.isChild
      }
    })
  })) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bbc6076","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-sup-components/Impiego.vue
// module id = 1442
// module chunks = 1